import { CurrencyRupee } from "@mui/icons-material";
import { Box, Checkbox, Chip, Typography } from "@mui/material";
import React from "react";
import { Input } from "../../../components";
import { IOrganization } from "../../../types/auth";
import cn from "../../../utils/cn";
import styles from "../ngo-org-page/Campaign-ngo.module.css";
import { mobileText } from "../../../utils/responsiveStyle";

interface OrgCardProps {
  organization: IOrganization;
  selectedOrg: { _id: string; value: string }[];
  onCheckboxChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    orgId: string,
  ) => void;
  onValueChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    orgId: string,
  ) => void;
  errors: Record<string, string>;
}

const OrgCard: React.FC<OrgCardProps> = React.memo(
  ({ organization, selectedOrg, onCheckboxChange, onValueChange, errors }) => {
    const { _id, name, title, description, darpanId, logo } = organization;

    const selectedItem = selectedOrg.find((item) => item._id === _id);
    const isSelected = !!selectedItem;

    return (
      <div
        className={cn(styles.orgCard, isSelected ? styles.selectedCard : "")}
      >
        <div>
          <div className={styles.ngoDetails}>
            <div className={styles.ngoDetailsLeft}>
              <Box className={styles.checkBoxContainer}>
                <Checkbox
                  sx={{ p: 0 }}
                  checked={isSelected}
                  onChange={(e) => onCheckboxChange(e, _id)}
                />
                <span
                  style={{
                    right: "0px",
                    top: "-12px",
                    backgroundColor: "var(--secondary-color-light)",
                    color: "var(--secondary-color)",
                    padding: "4px 12px",
                    textTransform: "capitalize",
                    fontSize: "10px",
                    fontWeight: 800,
                    textAlign: "center",
                    borderRadius: "100px",
                    letterSpacing: 0.8,
                  }}
                >
                  Organization
                </span>
              </Box>

              <Box sx={{ flex: 1, ml: 2 }}>
                <Typography
                  variant="h6"
                  className={styles.ngoName}
                  sx={{
                    ...mobileText,
                    fontWeight: 600,
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    lineHeight: 1.2,
                  }}
                >
                  {title || name}
                </Typography>

                {description && (
                  <Typography
                    variant="body2"
                    sx={{
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      mt: 0.5,
                    }}
                    className={styles.ngoDescription}
                  >
                    {description}
                  </Typography>
                )}

                {darpanId && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 0.5, display: "block" }}
                  >
                    Darpan ID: {darpanId}
                  </Typography>
                )}
                <Chip
                  label="ORGANIZATION"
                  variant="outlined"
                  sx={{ mt: 1.5 }}
                />
              </Box>
            </div>

            {/* Logo */}
            <div>
              <img
                alt="Organization logo"
                src={logo?.url || "/placeholder-logo.png"}
                className={styles.ngoImage}
              />
            </div>
          </div>
        </div>

        {/* Donation Input */}
        <div className={isSelected ? styles.donateCard : ""}>
          {isSelected && (
            <Input
              fullWidth
              value={selectedItem?.value ?? ""}
              label="Enter Amount"
              placeholder="Type the amount you want to donate"
              slotProps={{
                input: {
                  startAdornment: <CurrencyRupee sx={{ fontSize: 18 }} />,
                },
              }}
              onChange={(e) => onValueChange(e, _id)}
              error={!!errors[_id]}
              helperText={errors[_id]}
            />
          )}
        </div>
      </div>
    );
  },
);

export default OrgCard;
